export default "__VITE_ASSET__bbca5af9__"